/*
    node_js
    2/27/2021 7:06 PM
    by Oleksandr
*/
export const runways = [{
    "ICAOcode": "UKLL",
    "Runways": "31"
}]